import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowRightCircle } from "react-bootstrap-icons";
import starTrackerImg from "../assets/img/StarTracker-Transparent.png";

export const StarTrackerFeature = () => {
  return (
    <section
      className="startracker-feature"
      aria-labelledby="startracker-feature-title"
    >
      <Container>
        <Row className="align-items-center g-5">

          <Col xs={12} lg={6}>
            <div className="startracker-feature__image">
              <img
                src={starTrackerImg}
                alt="Kristal Fotonik Compact Star Tracker"
              />
            </div>
          </Col>

          <Col xs={12} lg={6}>
            <div className="startracker-feature__content">
              <span className="startracker-eyebrow">
                SPACE PRODUCTS
              </span>

              <h2 id="startracker-feature-title">
                Compact Star Tracker
              </h2>

              <p>
                Autonomous, low-power attitude determination for CubeSat,
  pico- and nanosatellite platforms. Its compact optical design
  enables precise tracking and straightforward spacecraft integration.
              </p>

              <div
                className="startracker-feature__specs"
                aria-label="Star Tracker key specifications"
              >
                <div>
                  <strong>30 arcsec</strong>
                  <span>Pitch / Yaw Accuracy</span>
                </div>

                <div>
                  <strong>10 Hz</strong>
                  <span>Update Rate</span>
                </div>

                <div>
                  <strong>1 W</strong>
                  <span>power consumption</span>
                </div>
              </div>

              <Link className="startracker-link" to="/startracker">
                Explore Star Tracker
                <ArrowRightCircle aria-hidden="true" />
              </Link>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};